import styled from "styled-components";

export const Container = styled.div`
  .inbox-table {
    /* max-height: calc(100vh - 114px);
    overflow: auto; */
    padding-top: 0;
    .table-head th {
      min-width: 150px;
      :first-child {
        max-width: 83px;
        min-width: auto;
      }
      :nth-last-child(3) {
        min-width: 160px;
      }
      :nth-last-child(2) {
        min-width: 166px;
      }
      :last-child {
        min-width: 341px;
      }
    }
  }
  @media (max-width: 850px) {
    /* padding: 10px; */
    /* max-height: calc(100vh - 184px); */
  }
`;

export const Header = styled.div`
  padding: 33px 24px 9.75px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid var(--table-heder-border);
  @media (max-width: 850px) {
    padding: 10px;
  }
`;

export const TableInnerSection = styled.div`
  /* width: 100%; */
  height: calc(100vh - 158px);
  &.no-pagination{
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }

  .super-time-theme--cell {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--text-primary);
    opacity: 0.5;
    font-weight: 500;
  }
  .action-btn {
    .round-btn {
      border-color: var(--border-color);
      color: var(--text-primary);
    }
  }
  .table-btn-wrapper {
    padding: 0;
    flex-wrap: nowrap;
  }
  .word-wrap{
    white-space: normal !important;
    word-break: break-word !important;
  }
  .delete-icon {
    cursor: pointer;
    margin-left: 45px;
  }
  @media (max-width: 850px) {
    height: calc(100vh - 248px);
    overflow-x: auto !important;

    /* Allowing table to scroll horizontally */
    .MuiDataGrid-root {
      width: auto !important;
      min-width: 100% !important;
    }
    
    .MuiDataGrid-main {
      width: auto !important;
      min-width: 100% !important;
    }

    .MuiDataGrid-virtualScrollerRenderZone {
      width: auto !important;
      min-width: 100% !important;
      
      > .MuiDataGrid-row {
        width: auto !important;
        min-width: 100% !important;
      }
    }

    .MuiCheckbox-root {
      padding: 9px 3px;
    }
    .action-btn {
      span {
        display: none;
      }
      .table-btn-wrapper {
        .round-btn {
          min-height: 21px;
          border-radius: 21px;
        }

        > .delete-icon {
          margin: 0;
        }
      }
    }
    .MuiDataGrid-row {
      position: relative;
      min-height: 78px !important;
      max-height: fit-content !important;
      height: auto !important;
      padding-bottom: 28px;
      
      > div {
        max-height: fit-content !important;
        min-height: fit-content !important;
        height: auto !important;
        box-sizing: border-box !important;
        
        :nth-child(2) {
          position: absolute;
          overflow: visible !important;
          min-height: fit-content !important;
          bottom: 6px;
          right: 0;
          max-width: max-content !important;
        }
        :nth-child(4) {
          max-width: 100% !important;
          flex: 1 !important;
          width: 100% !important;
          overflow: hidden !important;
          white-space: normal !important;
          word-wrap: break-word !important;
          word-break: break-word !important;
          
          * {
            max-width: 100% !important;
            overflow-wrap: break-word !important;
            word-wrap: break-word !important;
            word-break: break-word !important;
            box-sizing: border-box !important;
          }
        }
        :nth-child(5) {
          width: 84px !important;
          max-width: 84px !important;
          min-width: 84px !important;
          flex-shrink: 0 !important;
          overflow: hidden !important;
          word-wrap: break-word !important;
          
          > div, span {
            max-width: 100% !important;
            overflow: hidden !important;
            word-wrap: break-word !important;
          }
        }
        :nth-child(6) {
          width: 70px !important;
          max-width: 70px !important;
          min-width: 70px !important;
          flex-shrink: 0 !important;
          overflow: hidden !important;
          word-wrap: break-word !important;
          
          > div, span {
            max-width: 100% !important;
            overflow: hidden !important;
            word-wrap: break-word !important;
          }
        }
        :last-child {
          position: absolute;
          overflow: visible !important;
          min-height: fit-content !important;
          bottom: 6px;
          left: 22px;
        }
      }
    }
    .MuiDataGrid-columnHeader.lastcolumnSeparator.display,
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator.display {
      display: none;
    }
    .MuiDataGrid-columnHeadersInner {
      flex: 1;
      width: auto !important;
      min-width: 100% !important;
      
      > div {
        width: auto !important;
        min-width: 100% !important;
        
        > div {
          :nth-child(4) {
            max-width: 100% !important;
            flex: 1 !important;
            width: 100% !important;
            overflow: unset !important;
            white-space: normal !important;
          }
          :nth-child(5) {
            width: 84px !important;
            max-width: 84px !important;
            min-width: 84px !important;
          }
          :nth-child(6) {
            width: 70px !important;
            max-width: 70px !important;
            min-width: 70px !important;
          }
        }
      }
    }
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator.text-column {
      max-width: 100% !important;
      flex: 1;
    }
    .MuiDataGrid-columnHeaderTitle {
      font-size: 12px;
    }
  }
`;

export const ModalContainer = styled.div`
  .modal-container-parent {
    background: linear-gradient(180deg,#f3ede4 0%,#ffffff 100%);
    padding: 15px;
  }

  .modal-title-icon {
    display: flex;
    justify-content: space-between; 
    align-items: center;
    margin-bottom: 25px;
  }

  .modal-title {
    font-size: 25px; 
  }

  .modal-close-icon {
    align-self: flex-end;
  }

  .modal-message {
    display: inline;
    text-align: center;
  }

  .marshal-icon {
    display: inline;
    margin: 5px 0px 0px 10px;
    text-align: center;
  }
`;
